import React from 'react';
import {
  ComponentVerticalSpacing,
  ComponentWrapper,
  Button,
  BUTTON_TYPES
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

import ImageGrid from './ImageGrid';

const Content = props => {
  const { content } = props;
  return (
    <ComponentVerticalSpacing>
      <ComponentWrapper className="max-width-md margin-auto margin-top-lg">
        <div className="grid grid-gap-xl">
          <div className="col-6@sm flex items-center">
            <div className="text-component">
              <h2 className="d8-u-color-primary">{content.title}</h2>
              <p>{content.text}</p>
              {content.button && <Button buttonType={BUTTON_TYPES.PRIMARY} text={content.button.text} link={content.button.link} external={content.button.external} />}
            </div>
          </div>
          <div className="col-6@sm">
            <div className="margin-y-xl">
              <ImageGrid
                image={content.image}
              />
            </div>
          </div>
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  );
};


Content.propTypes = {
  content: PropTypes.object
};

export default Content;
